import moment, { utc } from 'moment'

export function setLocale () {
    const locale = window.navigator.userLanguage || window.navigator.language || 'en-gb'
    moment.locale(locale)
}

export function getLocale () {
    const locale = window.navigator.userLanguage || window.navigator.language || 'en-gb'
    return locale
}

export function getUserDateFormat () {
    const localeData = moment.localeData()
    const format = localeData.longDateFormat('L')
    return format
}

export function dateFormat (format) {
    switch (format) {
        case 'time':
            return 'LT'
        case 'timeWithSeconds':
            return 'LTS'
        case 'numericalDate':
            return 'L'
        case 'numericalDateTime':
            return 'L LTS'
        case 'longDate':
            return 'dddd LL'
        case 'longDateTime':
            return 'LLLL'
        case 'shortDate':
            return 'ddd ll'
        case 'shortDateTime':
            return 'lll'
        default:
            return 'L'
    }
}

export function displayDate ({ date, format }) {
    if (null == date) return '-'

    switch (format) {
        case 'time':
            return utc(date).local().format('LT')
        case 'timeWithSeconds':
            return utc(date).local().format('LTS')
        case 'numericalDate':
            return utc(date).local().format('L')
        case 'numericalDateTime':
            return utc(date).local().format('L LTS')
        case 'longDate':
            return utc(date).local().format('dddd LL')
        case 'longDateTime':
            return utc(date).local().format('LLLL')
        case 'shortDate':
            return utc(date).local().format('ddd ll')
        case 'shortDateTime':
            return utc(date).local().format('lll')
        default:
            return utc(date).local().format('L')
    }
}
